import React, { createContext, useCallback, useContext, useState } from "react";
import axiosInstance from "../Requests/axios";
import toast from "react-hot-toast";

const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState("");
  const [cartLoading, setCartLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const addToCart = async (offer_uuid) => {
    setButtonLoading((prev) => ({ ...prev, [offer_uuid]: true }));
    const url = `/cart/items`;
    const payload = { offer_uuid };

    try {
      await axiosInstance.post(url, payload);
      toast.success(`The offer has been added to cart`);
      fetchCartItems();
      setButtonLoading((prev) => ({ ...prev, [offer_uuid]: false }));
    } catch (error) {
      setButtonLoading((prev) => ({ ...prev, [offer_uuid]: false }));
      toast.error("There was an error adding offer to cart");
    }
  };

  const fetchCartItems = useCallback(async () => {
    try {
      setCartLoading(true);
      const response = await axiosInstance.get(`/cart/items/count`);
      setCartCount(response.data.count);
      setCartLoading(false);
    } catch (error) {
      setCartLoading(false);
      console.error("Failed to fetch cart items", error);
    }
  }, []);

  return (
    <CartContext.Provider
      value={{
        cartCount,
        addToCart,
        fetchCartItems,
        setCartCount,
        cartLoading,
        buttonLoading,
      }}
    >
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
